/* eslint-disable no-restricted-globals */
import { useEffect, useState } from 'react';

import { useConfiguraionContext } from '../../../context/ProviderPage/Configuration';
import { IConfigurationoDTO } from '../../../types/Configuration';
import { Option } from '../../../types/Option';
import { formatInputNumber } from '../../../utils/formatInputNumber';
import { toggleWithCascade } from '../../../utils/toggleWithCascade';
import { CustomSwitch } from '../../CustomSwitch';
import { ModalConfiguration } from '../InfoConfiguration/ModalConfiguration';
import {
  ColumnItens,
  ContainerItemMediumModal,
} from '../InfoConfiguration/ModalConfiguration/styles';

interface IEditOneAppConfiguration extends Option {
  titleModal: string;
}

export const EditOneAppConfiguration = ({
  titleModal,
  option,
}: IEditOneAppConfiguration) => {
  const {
    editOneConfiguration,
    setEditOneConfiguration,
    handleEditOneAppConfiguration,
    selectedConfiguration,
  } = useConfiguraionContext();

  const [DFDISTRIBUIR, setDFDISTRIBUIR] = useState(false);
  const [DFREGUAFRENTE, setDFREGUAFRENTE] = useState(false);
  const [DFREGUAATRAS, setDFREGUAATRAS] = useState(false);
  const [DFTERMOMENTRO, setDFTERMOMENTRO] = useState(false);
  const [DFLIBERARCOLETA, setDFLIBERARCOLETA] = useState(false);
  const [DFEXAMESENSORIAL, setDFEXAMESENSORIAL] = useState(false);
  const [DFEXAMEALIZAROL, setDFEXAMEALIZAROL] = useState(false);
  const [DFPASSOUNOALIZAROL, setDFPASSOUNOALIZAROL] = useState(false);
  const [DFFOTOSDEAMOSTRA, setDFFOTOSDEAMOSTRA] = useState(false);
  const [DFFOTOSDATEMPERATURA, setDFFOTOSDATEMPERATURA] = useState(false);
  const [DFFOTOREGUA1, setDFFOTOREGUA1] = useState(false);
  const [DFFOTOREGUA2, setDFFOTOREGUA2] = useState(false);
  const [DFAMOSTRA, setDFAMOSTRA] = useState(false);
  const [DFLACRE, setDFLACRE] = useState(false);
  const [DFATIVARPERCENTUALDELITRAGEM, setDFATIVARPERCENTUALDELITRAGEM] =
    useState(false);
  const [DFDIASDEVALIDACAO, setDFDIASDEVALIDACAO] = useState<string>('10');
  const [DFPORCENTAGEMDETOLERANCIA, setDFPORCENTAGEMDETOLERANCIA] =
    useState<string>('0');

  useEffect(() => {
    if (!selectedConfiguration) return;
    setDFDISTRIBUIR(selectedConfiguration.DFDISTRIBUIR === 'S');
    setDFREGUAFRENTE(selectedConfiguration.DFREGUAFRENTE === 'S');
    setDFREGUAATRAS(selectedConfiguration.DFREGUAATRAS === 'S');
    setDFTERMOMENTRO(selectedConfiguration.DFTERMOMENTRO === 'S');
    setDFLIBERARCOLETA(selectedConfiguration.DFLIBERARCOLETA === 'S');
    setDFEXAMESENSORIAL(selectedConfiguration.DFEXAMESENSORIAL === 'S');
    setDFEXAMEALIZAROL(selectedConfiguration.DFEXAMEALIZAROL === 'S');
    setDFPASSOUNOALIZAROL(selectedConfiguration.DFPASSOUNOALIZAROL === 'S');
    setDFFOTOSDEAMOSTRA(selectedConfiguration.DFFOTOSDEAMOSTRA === 'S');
    setDFFOTOSDATEMPERATURA(selectedConfiguration.DFFOTOSDATEMPERATURA === 'S');
    setDFFOTOREGUA1(selectedConfiguration.DFFOTOREGUA1 === 'S');
    setDFFOTOREGUA2(selectedConfiguration.DFFOTOREGUA2 === 'S');
    setDFAMOSTRA(selectedConfiguration.DFAMOSTRA === 'S');
    setDFLACRE(selectedConfiguration.DFLACRE === 'S');
    setDFATIVARPERCENTUALDELITRAGEM(
      selectedConfiguration.DFATIVARPERCENTUALDELITRAGEM === 'S',
    );
    setDFDIASDEVALIDACAO(
      String(selectedConfiguration.DFDIASDEVALIDACAO ?? '10'),
    );
    setDFPORCENTAGEMDETOLERANCIA(
      String(selectedConfiguration.DFPORCENTAGEMDETOLERANCIA ?? '0'),
    );
  }, [selectedConfiguration]);

  const config: IConfigurationoDTO = {
    DFDISTRIBUIR: DFDISTRIBUIR ? 'S' : 'N',
    // DFQUALIDADE: DFQUALIDADE ? 'S' : 'N',
    DFQUALIDADE: 'S',
    DFREGUAFRENTE: DFREGUAFRENTE ? 'S' : 'N',
    DFREGUAATRAS: DFREGUAATRAS ? 'S' : 'N',
    DFTERMOMENTRO: DFTERMOMENTRO ? 'S' : 'N',
    DFLIBERARCOLETA: DFLIBERARCOLETA ? 'S' : 'N',
    DFEXAMESENSORIAL: DFEXAMESENSORIAL ? 'S' : 'N',
    DFEXAMEALIZAROL: DFEXAMEALIZAROL ? 'S' : 'N',
    DFPASSOUNOALIZAROL: DFPASSOUNOALIZAROL ? 'S' : 'N',
    // DFAMOSTRADEQUALIDE: DFAMOSTRADEQUALIDE ? 'S' : 'N',
    DFAMOSTRADEQUALIDE: 'S',
    DFFOTOSDEAMOSTRA: DFFOTOSDEAMOSTRA ? 'S' : 'N',
    DFFOTOSDATEMPERATURA: DFFOTOSDATEMPERATURA ? 'S' : 'N',
    DFFOTOREGUA1: DFFOTOREGUA1 ? 'S' : 'N',
    DFFOTOREGUA2: DFFOTOREGUA2 ? 'S' : 'N',
    DFAMOSTRA: DFAMOSTRA ? 'S' : 'N',
    DFLACRE: DFLACRE ? 'S' : 'N',
    DFDIASDEVALIDACAO,
    DFATIVARPERCENTUALDELITRAGEM: DFATIVARPERCENTUALDELITRAGEM ? 'S' : 'N',
    DFPORCENTAGEMDETOLERANCIA,
  };

  const handleIncrement = () => {
    setDFDIASDEVALIDACAO(prev => (parseInt(prev, 10) + 1).toString());
  };

  const handleDecrement = () => {
    setDFDIASDEVALIDACAO(prev => {
      const newValue = parseInt(prev, 10) - 1;
      return newValue >= 0 ? newValue.toString() : prev;
    });
  };

  const handleIncrementTolerance = () => {
    setDFPORCENTAGEMDETOLERANCIA(prev => {
      const newValue = parseInt(prev, 10) + 1;
      return newValue <= 100 ? newValue.toString() : prev;
    });
  };

  const handleDecrementTolerance = () => {
    setDFPORCENTAGEMDETOLERANCIA(prev => {
      const newValue = parseInt(prev, 10) - 1;
      return newValue >= 0 ? newValue.toString() : prev;
    });
  };

  useEffect(() => {
    if (isNaN(Number(DFDIASDEVALIDACAO)) || DFDIASDEVALIDACAO === '') {
      setDFDIASDEVALIDACAO('10');
    } else if (DFDIASDEVALIDACAO === '0') {
      setDFDIASDEVALIDACAO('1');
    }
  }, [DFDIASDEVALIDACAO]);

  useEffect(() => {
    if (
      isNaN(Number(DFPORCENTAGEMDETOLERANCIA)) ||
      DFPORCENTAGEMDETOLERANCIA === ''
    ) {
      setDFPORCENTAGEMDETOLERANCIA('0');
    } else if (parseInt(DFPORCENTAGEMDETOLERANCIA, 10) < 0) {
      setDFPORCENTAGEMDETOLERANCIA('0');
    } else if (parseInt(DFPORCENTAGEMDETOLERANCIA, 10) > 100) {
      setDFPORCENTAGEMDETOLERANCIA('100');
    }
  }, [DFPORCENTAGEMDETOLERANCIA]);

  return (
    <ModalConfiguration
      option={option}
      titleModal={titleModal}
      closeModal={() => setEditOneConfiguration(false)}
      isOpen={editOneConfiguration}
      medium={true}
    >
      <ColumnItens>
        <ContainerItemMediumModal>
          <span>Obrigar Medição da régua da frontal: </span>
          <CustomSwitch
            action={() =>
              toggleWithCascade(
                DFREGUAFRENTE,
                setDFREGUAFRENTE,
                setDFFOTOREGUA1,
              )
            }
            isOpen={DFREGUAFRENTE}
          />
        </ContainerItemMediumModal>

        <ContainerItemMediumModal
          style={{
            opacity: DFREGUAFRENTE ? 1 : 0.5,
            pointerEvents: DFREGUAFRENTE ? 'auto' : 'none',
          }}
        >
          <span>Obrigar envio das fotos da Régua 1: </span>
          <CustomSwitch
            action={() => toggleWithCascade(DFFOTOREGUA1, setDFFOTOREGUA1)}
            isOpen={DFFOTOREGUA1}
          />
        </ContainerItemMediumModal>

        <ContainerItemMediumModal>
          <span>Obrigar Medição da régua traseira: </span>
          <CustomSwitch
            action={() =>
              toggleWithCascade(DFREGUAATRAS, setDFREGUAATRAS, setDFFOTOREGUA2)
            }
            isOpen={DFREGUAATRAS}
          />
        </ContainerItemMediumModal>

        <ContainerItemMediumModal
          style={{
            opacity: DFREGUAATRAS ? 1 : 0.5,
            pointerEvents: DFREGUAATRAS ? 'auto' : 'none',
          }}
        >
          <span>Obrigar envio das fotos da Régua 2: </span>
          <CustomSwitch
            action={() => toggleWithCascade(DFFOTOREGUA2, setDFFOTOREGUA2)}
            isOpen={DFFOTOREGUA2}
          />
        </ContainerItemMediumModal>

        <ContainerItemMediumModal>
          <span>Obrigar distribuição do leite: </span>
          <CustomSwitch
            action={() => toggleWithCascade(DFDISTRIBUIR, setDFDISTRIBUIR)}
            isOpen={DFDISTRIBUIR}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Obrigar contraprova de temperatura: </span>
          <CustomSwitch
            action={() => toggleWithCascade(DFTERMOMENTRO, setDFTERMOMENTRO)}
            isOpen={DFTERMOMENTRO}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Obrigar envio de fotos da temperatura: </span>
          <CustomSwitch
            action={() =>
              toggleWithCascade(DFFOTOSDATEMPERATURA, setDFFOTOSDATEMPERATURA)
            }
            isOpen={DFFOTOSDATEMPERATURA}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Obrigar liberação da coleta: </span>
          <CustomSwitch
            action={() =>
              toggleWithCascade(DFLIBERARCOLETA, setDFLIBERARCOLETA)
            }
            isOpen={DFLIBERARCOLETA}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Obrigar envio de exame sensorial: </span>
          <CustomSwitch
            action={() =>
              toggleWithCascade(DFEXAMESENSORIAL, setDFEXAMESENSORIAL)
            }
            isOpen={DFEXAMESENSORIAL}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Obrigar envio de exame alizarol: </span>
          <CustomSwitch
            action={() =>
              toggleWithCascade(DFEXAMEALIZAROL, setDFEXAMEALIZAROL)
            }
            isOpen={DFEXAMEALIZAROL}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Obrigar envio de passou no alizarol: </span>
          <CustomSwitch
            action={() =>
              toggleWithCascade(DFPASSOUNOALIZAROL, setDFPASSOUNOALIZAROL)
            }
            isOpen={DFPASSOUNOALIZAROL}
          />
        </ContainerItemMediumModal>

        <ContainerItemMediumModal>
          <span>Obrigar envio de fotos da amostra: </span>
          <CustomSwitch
            action={() =>
              toggleWithCascade(DFFOTOSDEAMOSTRA, setDFFOTOSDEAMOSTRA)
            }
            isOpen={DFFOTOSDEAMOSTRA}
          />
        </ContainerItemMediumModal>

        <ContainerItemMediumModal>
          <span>Obrigar envio da amostra: </span>
          <CustomSwitch
            action={() => toggleWithCascade(DFAMOSTRA, setDFAMOSTRA)}
            isOpen={DFAMOSTRA}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Obrigar envio do lacre: </span>
          <CustomSwitch
            action={() => toggleWithCascade(DFLACRE, setDFLACRE)}
            isOpen={DFLACRE}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Obrigar percentual de litragem: </span>
          <CustomSwitch
            action={() =>
              toggleWithCascade(
                DFATIVARPERCENTUALDELITRAGEM,
                setDFATIVARPERCENTUALDELITRAGEM,
              )
            }
            isOpen={DFATIVARPERCENTUALDELITRAGEM}
          />
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Dias para validação do percentual</span>

          <div className="input-container">
            <button
              className="decrement-button"
              onClick={handleDecrement}
              disabled={DFDIASDEVALIDACAO === '1'}
            >
              -
            </button>
            <input
              className="days-to-validation-input"
              value={DFDIASDEVALIDACAO}
              onChange={text =>
                setDFDIASDEVALIDACAO(formatInputNumber(text.target.value))
              }
            />
            <button className="increment-button" onClick={handleIncrement}>
              +
            </button>
          </div>
        </ContainerItemMediumModal>
        <ContainerItemMediumModal>
          <span>Percentual de Tolerância(%)</span>

          <div className="input-container">
            <button
              className="decrement-button"
              onClick={handleDecrementTolerance}
              disabled={DFPORCENTAGEMDETOLERANCIA === '0'}
            >
              -
            </button>
            <input
              className="days-to-validation-input"
              value={DFPORCENTAGEMDETOLERANCIA}
              onChange={text =>
                setDFPORCENTAGEMDETOLERANCIA(
                  formatInputNumber(text.target.value),
                )
              }
            />
            <button
              className="increment-button"
              onClick={handleIncrementTolerance}
              disabled={DFPORCENTAGEMDETOLERANCIA === '100'}
            >
              +
            </button>
          </div>
        </ContainerItemMediumModal>
        <button
          className="btn-action-button"
          onClick={() => handleEditOneAppConfiguration(config)}
        >
          Salvar
        </button>
      </ColumnItens>
    </ModalConfiguration>
  );
};
